// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// /Users/yuki/Dropbox/Mac/Desktop/web design/dog-ema-wp/wp-content/themes/ema/node_modules/lightbox2/dist/css/lightbox.min.css
// module id = 142
// module chunks = 0